module.exports = __webpack_public_path__ + "static/media/assa-no-option-selected.8d461c6a.svg";